import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';
//区域树
export async function getAreaTree(params) {
    return post(oaserver+'/dict/area/getAreaTree', params, true);
}

//大洲
export async function getContinents(params) {
    return post(oaserver+'/dict/area/getContinents', params, true);
}
//新增树
export async function addArea(params) {
    return post(oaserver+'/dict/area/addArea', params, true);
}
//编辑树
export async function editArea(params) {
    return post(oaserver+'/dict/area/editArea', params, true);
}